<template>
  <div id="app">
    <threeIndex />
  </div>
</template>

<script>
import threeIndex from './components/threeIndex.vue'

export default {
  name: 'app',
  components: {
    threeIndex
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  overflow:hidden;
  width: 100%;
  height: 100v;
  margin: 0;
  padding: 0;
}
body{
	margin: 0;
	padding: 0;
}
</style>
